/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type HelloRequest =
  | PrepAndSendRequest
  | SignerAppRequest
  | HSUserSchema
  | AccountFeatureSettings
  | AccountIntegrationSettings
  | AccountProfileSettings;
/**
 * Is third-party (or Dropbox) integration enabled for this request
 *
 * This interface was referenced by `Flags`'s JSON-Schema
 * via the `definition` "Integration".
 */
export type Integration = DeepIntegration | SharePointIntegration | HubSpotIntegration;
export type Field =
  | TextField
  | SignatureField
  | InitialsField
  | DateField
  | CheckboxField
  | RadioField
  | DropdownField
  | HyperlinkField;
export type TextField = {
  type: "text";
  pageIndex: number;
  id: string;
  apiId?: string;
  documentId: string;
  x: number;
  y: number;
  width: number;
  height: number;
  signer: string;
  required: boolean;
  readOnly: boolean;
  name: string;
  autoFillType?: AutoFillType;
  linkId?: string;
  isDisabled?: boolean;
  fontSize: FontSize;
  originalFontSize?: FontSize;
  fontFamily: FontFamily;
  value?: string;
  placeholder?: string;
  masked?: boolean;
  isEditableMergeField?: boolean;
  lines?: string;
  numLines?: number;
  numCharsPerLine?: number;
  lineHeight?: number;
  validationType?: ValidationType;
  validationCustomRegex?: string;
  validationCustomRegexFormatLabel?: string;
};
/**
 * Validation options available for a text field
 */
export type ValidationType =
  | "numbers_only"
  | "letters_only"
  | "phone_number"
  | "bank_routing_number"
  | "bank_account_number"
  | "email_address"
  | "zip_code"
  | "social_security_number"
  | "employer_identification_number"
  | "custom_regex";
export type SignatureField = {
  type: "signature";
  pageIndex: number;
  id: string;
  apiId?: string;
  documentId: string;
  x: number;
  y: number;
  width: number;
  height: number;
  signer: string;
  required: boolean;
  readOnly: boolean;
  name: string;
  linkId?: string;
  isDisabled?: boolean;
  signature?: Signature;
  color?: Color;
};
export type InitialsField = {
  type: "initials";
  pageIndex: number;
  id: string;
  apiId?: string;
  documentId: string;
  x: number;
  y: number;
  width: number;
  height: number;
  signer: string;
  required: boolean;
  readOnly: boolean;
  name: string;
  linkId?: string;
  isDisabled?: boolean;
  signature?: Signature;
  color?: Color;
};
export type DateField = {
  pageIndex: number;
  id: string;
  apiId?: string;
  documentId: string;
  x: number;
  y: number;
  width: number;
  height: number;
  signer: string;
  required: boolean;
  readOnly: boolean;
  name: string;
  linkId?: string;
  isDisabled?: boolean;
  fontSize: FontSize;
  originalFontSize?: FontSize;
  fontFamily: FontFamily;
  lineHeight?: number;
  value: string | null;
  placeholder?: string;
  type: "date";
  dateFormat?: JSDateFormat;
};
export type CheckboxField = {
  pageIndex: number;
  id: string;
  apiId?: string;
  documentId: string;
  x: number;
  y: number;
  width: number;
  height: number;
  signer: string;
  required: boolean;
  readOnly: boolean;
  name: string;
  isDisabled?: boolean;
  type: "checkbox";
  checked?: boolean;
  requirement?: string;
  groupLabel?: string;
  group?: string;
};
export type RadioField = {
  pageIndex: number;
  id: string;
  apiId?: string;
  documentId: string;
  x: number;
  y: number;
  width: number;
  height: number;
  signer: string;
  required: boolean;
  readOnly: boolean;
  name: string;
  linkId?: string;
  isDisabled?: boolean;
  type: "radiobutton";
  checked: boolean;
  requirement: string;
  groupLabel?: string;
  group: string;
};
export type DropdownField = {
  pageIndex: number;
  id: string;
  apiId?: string;
  documentId: string;
  x: number;
  y: number;
  width: number;
  height: number;
  signer: string;
  required: boolean;
  readOnly: boolean;
  name: string;
  isDisabled?: boolean;
  type: "dropdown";
  value?: string | null;
  options: string[];
  fontSize: FontSize;
  fontFamily: FontFamily;
  lineHeight?: number;
};
export type HyperlinkField = {
  type: "hyperlink";
  pageIndex: number;
  id: string;
  apiId?: string;
  documentId: string;
  x: number;
  y: number;
  width: number;
  height: number;
  signer: string;
  required: boolean;
  readOnly: boolean;
  name: string;
  autoFillType?: AutoFillType;
  linkId?: string;
  isDisabled?: boolean;
  lineHeight?: number;
  fontFamily: FontFamily;
  fontSize: FontSize;
  value: string | null;
  url: string;
};
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "Action".
 */
export type Action = FieldVisibilityAction | GroupVisibilityAction;
export type Recipient = Role | Signer | FaxRecipient;
/**
 * This interface was referenced by `EditorData`'s JSON-Schema
 * via the `definition` "SignatureTypes".
 */
export type SignatureTypes = "draw" | "type" | "upload" | "phone";

export interface PrepAndSendRequest {
  guid: string;
  settings: Settings;
  options: Options;
  flags: Flags;
  accountSettings: AccountSettings;
  requestData: RequestData;
  embeddedData?: EmbeddedData;
  apiApp?: ApiApp;
  user: User;
}
export interface Settings {
  addCoverPage?: boolean;
  recipientOrder?: boolean;
  qes?: boolean;
  recipientReassignment?: boolean;
  requireSignerInfo?: boolean;
  sendHighResFax?: boolean;
  needsCharge?: boolean;
}
export interface Options {
  /**
   * Embedded - force showing signer roles
   */
  forceSignerRoles?: boolean;
  /**
   * Embedded - force showing subject message
   */
  forceSubjectMessage?: boolean;
  /**
   * Embedded - force showing subject message
   */
  hideContinueButton?: boolean;
  isMeOnly?: boolean;
  /**
   * Hide Stepper icons
   */
  hideProgressStepper?: boolean;
  /**
   * Hide entire stepper
   */
  hideStepperContainer?: boolean;
  /**
   * Show modal asking for user first & last name
   */
  requireSignerInfo?: boolean;
  /**
   * Block use of CCs
   */
  blockCC?: boolean;
  /**
   * Lock the title
   */
  lockDocumentTitle?: boolean;
  /**
   * Lock the message
   */
  lockDocumentMessage?: boolean;
  dateFormat?: JSDateFormat;
  /**
   * A list of features that are being made available on this request
   */
  features?: string[];
  /**
   * Integration super group metadata
   */
  integrationMetadata?: any[];
}
export interface Flags {
  requestType: RequestType;
  /**
   * Is this HelloFax (vs HelloSign)?
   */
  isHelloFax?: boolean;
  /**
   * True if this is coming from a resend or draft flow
   */
  isResend?: boolean;
  /**
   * True if this request is coming from the Mobile app
   */
  isMobileAppRequest?: boolean;
  integration?: Integration;
  /**
   * True if the underlying template for edit-and-resend has been modified
   */
  hasTemplateReuseWarning?: boolean;
  /**
   * True if this is coming from a third party signup flow
   */
  shouldRouteToPrepAndSend?: boolean;
  /**
   * True if subscription is eligible for creating template
   */
  displayDocToTemplateBanner?: boolean;
  /**
   * DocToTemplateV2ABTest variation either V1|V2|control
   */
  docToTemplateCurrentVariation?: boolean;
  /**
   * True if Doc to template banner checkbox is checked
   */
  shouldConvertDocToTemplate?: boolean;
  /**
   * Document to Template conversion ID
   */
  templateConversionCandidateId?: string;
}
/**
 * This interface was referenced by `Flags`'s JSON-Schema
 * via the `definition` "DeepIntegration".
 */
export interface DeepIntegration {
  name?: IntegrationName;
  data?: IntegrationData;
}
/**
 * Data relevant to integrations
 *
 * This interface was referenced by `Flags`'s JSON-Schema
 * via the `definition` "IntegrationData".
 */
export interface IntegrationData {
  externalCacheKey: string;
  externalAppKey: string;
  externalAccountId: string;
  externalFolderPath: string;
  externalFileName?: string;
  externalDefaultSavePath?: string;
}
/**
 * This interface was referenced by `Flags`'s JSON-Schema
 * via the `definition` "SharePointIntegration".
 */
export interface SharePointIntegration {
  name?: IntegrationName1;
  data?: IntegrationData;
}
/**
 * This interface was referenced by `Flags`'s JSON-Schema
 * via the `definition` "HubSpotIntegration".
 */
export interface HubSpotIntegration {
  name?: IntegrationName2;
  data?: IntegrationData;
}
export interface AccountSettings {
  /**
   * Allow user to select a file from third-party website on 'Select documents' page
   */
  allowIntegrationsUpload?: boolean;
  /**
   * Ability to add signer pin per signer as part of the signature request
   */
  allowRecipientAccessCodes?: boolean;
  /**
   * Ability to add signer SMS authentication per signer as part of the signature request
   */
  allowRecipientSmsAuthNumbers?: boolean;
  /**
   * Ability to require signers to attach (both required or optional) attachments as part of their signing process
   */
  allowRecipientAttachments?: boolean;
  /**
   * Allow recipient reassignment checkbox on 'Add signers' page
   */
  allowRecipientReassignment?: boolean;
  /**
   * Should this user be given the ability to send Qualified E-Signatures
   */
  allowQualifiedSignature?: boolean;
  /**
   * The SMS tools add-on has been purchased and this account has permission to use it
   */
  allowSmsSignatureDelivery?: boolean;
  /**
   * Allow template deletion from P&S workflow
   */
  allowTemplateDelete: boolean;
  /**
   * True if the current account has permission to create/edit templates
   */
  allowCreateEditTemplate?: boolean;
  /**
   * True if the current account has the ability to preview templates
   */
  allowTemplatePreview?: boolean;
  /**
   * Allow template signature requests to have optional signers if at least one signer is populated.
   */
  allowOptionalTemplateSigners?: boolean;
  /**
   * Allow SMS authentication
   */
  allowSmsAuth?: boolean;
  /**
   * Allow bulk send
   */
  allowBulkSend?: boolean;
  /**
   * Has a non-Enterprise+ plan that can use recipient access codes regardless of setting
   */
  canAccessRecipientAccessCodes?: boolean;
  /**
   * User's add-on tier for SMS Signature Delivery can be auto-upgraded
   */
  canUpgradeTierSmsSignatureDelivery?: boolean;
  /**
   * Is the account prevented from sending faxes to multiple recipients
   */
  noMultiFaxes?: boolean;
  /**
   * User subscription template quota
   */
  maxTemplateNumber?: number;
  /**
   * Is user at their account-type's limit for creating templates?
   */
  isAtTemplateLimit?: boolean;
  /**
   * Is user at their account-type's limit for sending signature request?
   */
  isAtDocumentLimit?: boolean;
  /**
   * Does the user's subsription have the HIPAA tag?
   */
  hasHIPAA?: boolean;
  /**
   * Is the plan in context a Blueberry plan?
   */
  isNewHsPlan?: boolean;
  /**
   * Is the plan in context a transactional plan?
   */
  isTransactionalPlan?: boolean;
  /**
   * User wants a copy of PDF/Fax sent to themselves
   */
  alwaysSendMeACopy?: boolean;
  /**
   * User wants a copy of complete/faxed PDF sent to recipients and CCs
   */
  alwaysSendOthersACopy?: boolean;
  /**
   * True if the fax request needs a one-time charge
   */
  needsCharge?: boolean;
  /**
   * Which charge flow the user needs to see
   */
  chargeType?: string;
  /**
   * The total price of the charge in cents
   */
  totalPriceInCents?: number;
  /**
   * The amount of free faxes the account has left
   */
  freeFaxPagesLeft?: number;
  /**
   * The amount of fax pages in the current request
   */
  faxPageCurrentCount?: number;
  /**
   * The maximum fax price users can send in a free account
   */
  overageFaxMaxLimitInCents?: number;
  /**
   * The normal price for a fax on the account's subscription
   */
  pricePerFaxInCents?: number;
  /**
   * How many pages until you are over the initial pricePerFax
   */
  initialPageLimit?: number;
  /**
   * How much each page costs after your initial limit
   */
  overagePriceInCentsPerPage?: number;
  /**
   * How much the price of a page multiplies based on the receiving country
   */
  internationalMultiplier?: number;
  uploadIntegrations: UploadIntegrations;
  /**
   * The SMS tools add-on has been purchased AND its setting is turned on via Admin Console
   */
  isSMSToolsOn?: boolean;
}
/**
 * This interface was referenced by `AccountSettings`'s JSON-Schema
 * via the `definition` "UploadIntegrations".
 */
export interface UploadIntegrations {
  D?: DropboxIntegration;
  T?: OneDriveIntegration;
  G?: GoogleDriveIntegration;
  B?: BoxIntegration;
  E?: EvernoteIntegration;
}
/**
 * This interface was referenced by `AccountSettings`'s JSON-Schema
 * via the `definition` "DropboxIntegration".
 */
export interface DropboxIntegration {
  id: "D";
  key: string;
  nonce: string;
  enabled: boolean;
}
/**
 * This interface was referenced by `AccountSettings`'s JSON-Schema
 * via the `definition` "OneDriveIntegration".
 */
export interface OneDriveIntegration {
  id: "T";
  token?: string;
  clientId: string;
  nonce: string;
  enabled: boolean;
}
/**
 * This interface was referenced by `AccountSettings`'s JSON-Schema
 * via the `definition` "GoogleDriveIntegration".
 */
export interface GoogleDriveIntegration {
  id: "G";
  key: string;
  token?: string;
  abbrKey: string;
  enabled: boolean;
}
/**
 * This interface was referenced by `AccountSettings`'s JSON-Schema
 * via the `definition` "BoxIntegration".
 */
export interface BoxIntegration {
  id: "B";
  enabled: boolean;
}
/**
 * This interface was referenced by `AccountSettings`'s JSON-Schema
 * via the `definition` "EvernoteIntegration".
 */
export interface EvernoteIntegration {
  id: "E";
  enabled: boolean;
}
export interface RequestData {
  files: File[];
  editorData: EditorData;
  recipients: Recipient[];
  ccs: (CCEmail | CCRole)[];
  title: string;
  message: string;
  templates: Template[];
  coverPage?: CoverPage;
  bulkSend: BulkSend;
}
export interface File {
  status?: Status;
  name: string;
  type: Type;
  guid: string;
  documentGuid?: string;
  draftSnapshotGuid?: string;
  tsmGroupGuid?: string;
  templateGuid?: string;
  rootSnapshotGuid: string;
  order?: number;
  fields: Field[];
  pwRequired: boolean;
  pageCount?: number;
  externalFileCacheKey?: string;
  externalServiceReference?: string;
  externalServiceType?: string;
}
export interface Signature {
  type: SignatureType;
  createType?: SignatureCreateType;
  createdAt?: string;
  lastUsedAt?: string;
  guid: string;
  width?: number;
  height?: number;
}
export interface EditorData {
  pages: Page[];
  fields: Field[];
  mergeFields: Field[];
  pdfFields: Field[];
  editorFeatures?: string[];
  rules: Rule[];
  transform: Transform;
  documents: Document[];
  signers: Recipient[];
  signerOptions: SignerOptions;
  editorOptions: EditorOptions;
}
export interface Page {
  src: string;
  width: number;
  height: number;
  documentId: string;
  orientation: number;
  snapshotGuid: string;
  cdnSrc?: string | null;
}
export interface Rule {
  id: string;
  triggerOperator: TriggerOperator;
  triggers: (StringArrayTrigger | StringTrigger | NonNumericTrigger | NumericTrigger)[];
  actions: Action[];
}
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "StringArrayTrigger".
 */
export interface StringArrayTrigger {
  id: string;
  operator: StringArrayOperator;
  value: string[];
}
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "StringTrigger".
 */
export interface StringTrigger {
  id: string;
  operator: StringOperator;
  value: string;
}
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "NonNumericTrigger".
 */
export interface NonNumericTrigger {
  id: string;
  operator: NonNumericOperator;
  value: string | boolean;
}
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "NumericTrigger".
 */
export interface NumericTrigger {
  id: string;
  operator: NumericOperator;
  value: number;
}
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "FieldVisibilityAction".
 */
export interface FieldVisibilityAction {
  type: "change-field-visibility";
  fieldId: string;
  hidden: boolean;
}
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "GroupVisibilityAction".
 */
export interface GroupVisibilityAction {
  type: "change-group-visibility";
  groupId: string;
  hidden: boolean;
}
export interface Transform {
  rotate: number;
}
/**
 * Holds information about documents uploaded as part of the request. This is separate from files uploaded on the Prep and Send documents page because the ability to upload documents is available in the Editor as well.
 *
 * This interface was referenced by `EditorData`'s JSON-Schema
 * via the `definition` "Document".
 */
export interface Document {
  id: string;
  name: string;
  editable: boolean;
  snapshotGuid: string;
}
export interface Role {
  type: "role";
  id: string;
  name: string;
  attachments: Attachment[];
  accessCode?: string;
  smsAuthNumber?: string;
  order?: number;
}
export interface Attachment {
  id: string;
  name: string;
  instructions: string;
  required: boolean;
}
export interface Signer {
  type: "signer";
  id: string;
  email: string | null;
  name: string;
  role: null | Role;
  attachments: Attachment[];
  accessCode?: string;
  smsAuthNumber?: string;
  authType?: string;
  smsDeliveryNumber?: string;
  deliveryType?: DeliveryType;
  order?: number;
}
export interface FaxRecipient {
  type: "fax";
  id: string;
  fax: string;
}
/**
 * This interface was referenced by `EditorData`'s JSON-Schema
 * via the `definition` "SignerOptions".
 */
export interface SignerOptions {
  fieldOptions?: FieldOptions;
  signatureType?: SignatureType1;
}
/**
 * This interface was referenced by `EditorData`'s JSON-Schema
 * via the `definition` "FieldOptions".
 */
export interface FieldOptions {
  dateFormat?: JSDateFormat;
}
/**
 * This interface was referenced by `EditorData`'s JSON-Schema
 * via the `definition` "SignatureType".
 */
export interface SignatureType1 {
  default?: SignatureTypes;
  allowed?: SignatureTypes[];
}
/**
 * This interface was referenced by `EditorData`'s JSON-Schema
 * via the `definition` "EditorOptions".
 */
export interface EditorOptions {
  allowEditSigners: boolean;
  allowEditDocuments: boolean;
  canUseCustomRegexDataValidation: boolean;
  canUseDataValidation: boolean;
}
export interface CCEmail {
  type: "ccEmail";
  id: string;
  email: string;
  role?: CCRole;
}
export interface CCRole {
  type: "ccRole";
  id: string;
  name: string;
}
export interface Template {
  guid: string;
  requestType: number;
  recipientReassignment: boolean;
  starred?: boolean;
  recipientOrder: boolean;
  updated?: string;
  dateFormat: PHPDateFormat;
  jsDateFormat?: JSDateFormat;
  files?: File[];
  editorData?: EditorData;
  recipients: Recipient[];
  ccs?: (CCRole | CCEmail)[];
  title: string;
  message: string;
  locked?: boolean;
  shortGuid?: string;
  isOwner: boolean;
  isEditable?: boolean;
  isDeletable?: boolean;
  isEmbedded?: boolean;
  isSalesforceCreated?: boolean;
  linkDetails?: LinkDetails;
  createdBy: CreatedBy;
}
/**
 * This interface was referenced by `Template`'s JSON-Schema
 * via the `definition` "LinkDetails".
 */
export interface LinkDetails {
  shareableLink?: string;
  inPersonLink?: string;
  receiveSignedCopies: boolean;
}
/**
 * This interface was referenced by `Template`'s JSON-Schema
 * via the `definition` "CreatedBy".
 */
export interface CreatedBy {
  name: string;
  email: string;
  date: string;
}
export interface CoverPage {
  to: string;
  from: string;
  message: string;
}
export interface BulkSend {
  exampleFields: string[];
  signerFile: File | null;
}
export interface EmbeddedData {
  docGuids: string[];
  isEmbeddedRequest?: boolean;
  isEmbeddedTemplate?: boolean;
  isGmail?: boolean;
  skipMeNow?: boolean;
  usingTemplate: boolean;
  isCreatedFromTemplate?: boolean;
  parentUrl: string;
  redirectUrl: string;
  editedTemplateGuid?: string | null;
  isSelfSign: boolean | null;
  locale: string | null;
  appName?: string;
}
export interface ApiApp {
  clientId: string;
  parentUrl: string;
}
export interface User {
  name?: string;
  firstName?: string;
  lastName?: string;
  email: string;
  isPaidAccount: boolean;
  isConfirmedAccount: boolean;
  title?: string;
  company?: string;
  apiIdsEnabled: boolean;
  accountDateFormat: AccountDateFormat;
}
export interface SignerAppRequest {
  pages: Page[];
  fields: Field[];
  rules: Rule[];
}
export interface HSUserSchema {
  id: number;
  guid: string;
  emailAddress: string;
  name: string;
  settings: {
    firstName: string;
    lastName: string;
  };
  isFree: boolean;
  hasTeam: boolean;
  plan:
    | "(Grandfathered 2016)"
    | "API Basic"
    | "Business 10"
    | "Business"
    | "Enterprise"
    | "Enterprise+"
    | "Essentials"
    | "Free Premium"
    | "Free"
    | "Grandfathered"
    | "Premium"
    | "Standard"
    | "Test Mode"
    | "Web 300k";
  numApiDocsLeft: number;
  numDocsLeft: number;
  numTemplatesLeft: number;
  numFaxPagesLeft: number;
  canAccessBulkSendUI: boolean;
  canAccessAdminConsole: boolean;
  canAccessTemplateConverter: boolean;
  noTimeout: boolean;
  isFromSelfServeApi: boolean;
  primarySignatureGuid?: string;
  showApiCredits: boolean;
  canCreateEditTemplate: boolean;
  hasLegacyApiKeys: boolean;
  referUrl: string;
}
export interface AccountFeatureSettings {
  hasCustomLogo: boolean;
  customLogoUrl: string;
  isAccountLogoTeamLogo: boolean;
  companyTagline: string;
  emailFrom: string;
  emailSignature: string;
  isCustomSigningRedirectEnabled: boolean;
  customSigningRedirectUrl: string;
  areDrawnSignaturesAccepted: boolean;
  areTypedSignaturesAccepted: boolean;
  areUploadedSignaturesAccepted: boolean;
  areSmartphoneSignaturesAccepted: boolean;
  shouldIncludeDistinctPdfs: boolean;
  shouldRemoveDocumentId: boolean;
  hasSubscriptionAccess: boolean;
  shouldEnableInPersonSigning: boolean;
  enabledFeatures: AccountFeaturePermissions;
  esignDisclosureSettings?: ESignDisclosureSettings;
  dataResidencySettings?: DataResidencySettings;
}
/**
 * This interface was referenced by `AccountFeatureSettings`'s JSON-Schema
 * via the `definition` "AccountFeaturePermissions".
 */
export interface AccountFeaturePermissions {
  isBrandingEnabled?: boolean;
  hasDataResidency?: boolean;
}
/**
 * This interface was referenced by `AccountFeatureSettings`'s JSON-Schema
 * via the `definition` "EsignDisclosureSettings".
 */
export interface ESignDisclosureSettings {
  esignDisclosureEnable?: boolean;
  esignDisclosureAdditionalTextEnable?: boolean;
  esignDisclosureBusinessName?: string;
  esignDisclosureAdditionalText?: string;
}
/**
 * This interface was referenced by `AccountFeatureSettings`'s JSON-Schema
 * via the `definition` "DataResidencySettings".
 */
export interface DataResidencySettings {
  dataResidencyEnabled: boolean;
  selectedDataResidency: string;
  dataResidencyOptions: string[];
}
export interface AccountIntegrationSettings {
  authUrl?: string;
  integrationSettings: (EditableIntegration | LinkedIntegration)[];
}
/**
 * This interface was referenced by `AccountIntegrationSettings`'s JSON-Schema
 * via the `definition` "EditableIntegration".
 */
export interface EditableIntegration {
  name: string;
  serviceTypeCode: string;
  isEnabled: boolean;
  isActive: boolean;
}
/**
 * This interface was referenced by `AccountIntegrationSettings`'s JSON-Schema
 * via the `definition` "LinkedIntegration".
 */
export interface LinkedIntegration {
  name: string;
  isEnabled: boolean;
  buttonLink: string;
}
export interface AccountProfileSettings {
  isHf: boolean;
  supportEmailAddress: string;
  canChangeEmailAddress: boolean;
  email: string;
  numContacts: number;
  faxNumbers: string[];
  hasDKIMAuthentication: boolean;
  hasSPFAuthentication: boolean;
  isEmailAuthenticationEnabled: boolean;
  hasPendingSignatures: boolean;
  hasPaidSubscription: boolean;
  canChangePassword: boolean;
  hasTempPassword: boolean;
  isAccountConfirmed: boolean;
  showEsignDisclosure: boolean;
  firstName: string;
  lastName: string;
  accountLocale: string;
  company: string;
  industry: string;
  jobTitle: string;
  department: string;
  dateFormat: string;
  isTimezoneLocked: boolean;
  timezone: string;
  shouldAutocomplete: boolean;
  shouldEnableTamperProof: boolean;
  hasTeam?: boolean;
  isTeamAdmin?: boolean;
  numTeamMembers: number;
  canDeleteAccount: boolean;
  hasSubscription: boolean;
  hasSubscriptionFrom: string;
  cancelUrl: string;
  hasBillingRestriction: boolean;
  notifications: AccountProfileNotifications;
  multiFactorPhoneNumber: string;
  hasMultiFactorSMSVerification: boolean;
  hasMultiFactorGoogleAuthenticator: boolean;
  hasGoogleAuthenticatorAccess: boolean;
  hasSMSVerficationAccess: boolean;
  businessName: string;
  additionalDisclosureText: string;
  hasEsignDisclosureAccess: boolean;
  timezoneOptions: Timezone[];
  hipaaLock: HipaaLock;
  cancelSubscriptionLink: string;
}
/**
 * This interface was referenced by `AccountProfileSettings`'s JSON-Schema
 * via the `definition` "AccountProfileNotifications".
 */
export interface AccountProfileNotifications {
  shouldIncludeReceivedFaxPDFs: boolean;
  shouldIncludeReceivedFaxPDFsForOthers: boolean;
  shouldIncludeSentFaxPDFs: boolean;
  isOptedInMarketingEmails: boolean;
  isSignatureRemindersEnabled: boolean;
  shouldSendOutboundConfEmails: boolean;
  isNotifyOnSignEnabled: boolean;
  isNotifyOnViewEnabled: boolean;
  shouldSendEmbeddedSignatureConfEmails: boolean;
  shouldSendDailySummary: boolean;
  shouldSendOrderedSREmail: boolean;
  shouldIncludeRequestedPDFs: boolean;
  shouldIncludeRequestedPDFsForOthers: boolean;
  shouldIncludeSentDocPDFs: boolean;
  shouldIncludeSentDocPDFsForOthers: boolean;
  isEmailAuthenticationEnabled: boolean;
  notifyCCOnDocumentSend: boolean;
  notifyCCOnDocumentCompleted: boolean;
  notifyCCOnDocumentDeclined: boolean;
  notifyCCOnDocumentView: boolean;
  notifyCCOnDocumentDelegate: boolean;
  hasSMSSignatureDelivery: boolean;
}
export interface Timezone {
  offset: number;
  hasDST: boolean;
  displayName: string;
}
/**
 * This interface was referenced by `AccountProfileSettings`'s JSON-Schema
 * via the `definition` "HipaaLock".
 */
export interface HipaaLock {
  shouldIncludeReceivedFaxPDFs: boolean;
  shouldIncludeReceivedFaxPDFsForOthers: boolean;
  shouldIncludeSentFaxPDFs: boolean;
  shouldIncludeRequestedPDFs: boolean;
  shouldIncludeRequestedPDFsForOthers: boolean;
  shouldIncludeSentDocPDFs: boolean;
  shouldIncludeSentDocPDFsForOthers: boolean;
}

export enum JSDateFormat {
  JSDefault = "default",
  MMDDYYYYSeparatedBySlash = "MM / DD / YYYY",
  MMDDYYYYSeparatedByHyphen = "MM - DD - YYYY",
  DDMMYYYYSeparatedBySlash = "DD / MM / YYYY",
  DDMMYYYYSeparatedByHyphen = "DD - MM - YYYY",
  YYYYMMDDSeparatedBySlash = "YYYY / MM / DD",
  YYYYMMDDSeparatedByHyphen = "YYYY - MM - DD"
}
/**
 * This interface was referenced by `Flags`'s JSON-Schema
 * via the `definition` "RequestType".
 */
export enum RequestType {
  SendDoc = 1,
  RequestSig = 2,
  ResponseSig = 3,
  Template = 4,
  SendTemplate = 5,
  Demo = 7,
  FinalizeDocGmail = 8,
  ReusableLink = 9,
  SelfSave = 10,
  EmbeddedRequest = 11,
  EmbeddedTemplate = 12,
  BulkSend = 13
}
export enum IntegrationName {
  DeepIntegration = "deepintegration",
  OfficeSelfSign = "officeAddInSelfSign"
}
export enum IntegrationName1 {
  SharePoint = "SharePoint"
}
export enum IntegrationName2 {
  HubSpot = "hubspot"
}
/**
 * This interface was referenced by `AccountSettings`'s JSON-Schema
 * via the `definition` "UploadIntegrationType".
 */
export enum UploadIntegrationType {
  Box = "B",
  Dropbox = "D",
  Evernote = "E",
  GoogleDrive = "G",
  OneDrive = "T"
}
export enum Status {
  Converting = "converting",
  Ok = "ok",
  FileDownloaded = "file downloaded",
  Downloading = "downloading",
  DownloadQueued = "download queued",
  Deleted = "deleted",
  Error = "error",
  Error404 = "404 Error",
  PasswordRequired = "password required",
  TooManyPages = "too many pages",
  FileTooLarge = "file too large",
  RetrieveError = "retrieve error",
  BadRequest = "bad request",
  BadAuth = "bad auth"
}
export enum Type {
  Upload = "Upload",
  Template = "Template",
  External = "External",
  Signer = "Signer"
}
export enum AutoFillType {
  FullName = "name",
  LastName = "lastName",
  FirstName = "firstName",
  Company = "company",
  Email = "email",
  Title = "title",
  None = "none"
}
export enum FontSize {
  Seven = 7,
  Eight = 8,
  Nine = 9,
  Ten = 10,
  Twelve = 12,
  Fourteen = 14,
  Sixteen = 16,
  Eighteen = 18,
  Twenty = 20,
  TwentyTwo = 22,
  TwentyFour = 24,
  TwentySix = 26,
  TwentyEight = 28,
  ThirtySix = 36,
  FortyTwo = 42,
  FortyEight = 48
}
export enum FontFamily {
  Helvetica = "helvetica",
  Arial = "arial",
  Calibri = "calibri",
  Cambria = "cambria",
  Courier = "courier",
  Georgia = "georgia",
  Times = "times",
  Trebuchet = "trebuchet",
  Verdana = "verdana",
  NotoSerif = "notoSerif",
  NotoSans = "notoSans",
  Roboto = "roboto",
  RobotoMono = "robotoMono"
}
export enum SignatureType {
  Signature = "S",
  Initials = "I"
}
export enum SignatureCreateType {
  Canvas = "C",
  Upload = "U",
  Typed = "T",
  Email = "E"
}
export enum Color {
  Black = "black",
  Blue = "blue",
  Red = "red"
}
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "TriggerOperator".
 */
export enum TriggerOperator {
  AND = "AND",
  OR = "OR"
}
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "StringArrayOperator".
 */
export enum StringArrayOperator {
  Any = "any",
  None = "none"
}
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "StringOperator".
 */
export enum StringOperator {
  Has = "has",
  HasNot = "hasNot",
  Match = "match"
}
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "NonNumericOperator".
 */
export enum NonNumericOperator {
  Is = "is",
  Not = "not"
}
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "NumericOperator".
 */
export enum NumericOperator {
  Lt = "gt",
  Gt = "lt"
}
/**
 * This interface was referenced by `Rule`'s JSON-Schema
 * via the `definition` "ActionType".
 */
export enum ActionType {
  ChangeFieldVisibility = "change-field-visibility",
  ChangeGroupVisibility = "change-group-visibility"
}
export enum DeliveryType {
  Email = "EMAIL",
  EmailAndSMS = "EMAIL-SMS"
}
export enum PHPDateFormat {
  Default = "Default",
  MMDDYYYYSeparatedBySlash = "m / d / Y",
  MMDDYYYYSeparatedByHyphen = "m - d - Y",
  DDMMYYYYSeparatedBySlash = "d / m / Y",
  DDMMYYYYSeparatedByHyphen = "d - m - Y",
  YYYYMMDDSeparatedBySlash = "Y / m / d",
  YYYYMMDDSeparatedByHyphen = "Y - m - d"
}
/**
 * Preferred date format on account settings
 *
 * This interface was referenced by `User`'s JSON-Schema
 * via the `definition` "AccountDateFormat".
 */
export enum AccountDateFormat {
  MMDDYYYY = "MM / DD / YYYY",
  DDMMYYYY = "DD / MM / YYYY",
  YYYYMMDD = "YYYY / MM / DD"
}
